import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Time from 'react-time';
import { WidgetsStatusBadge } from '../../../projects/ProjectDashboard/WidgetsStatusBadge';

const getStatus = (startDate, endDate) => {
  const now = moment();
  if (now.isAfter(endDate, 'day')) return 'completed';
  if (now.isBefore(startDate, 'day')) return 'upcoming';
  return 'active';
};

DateRange.propTypes = {
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
};

function DateRange({ startDate, endDate }) {
  const showDateRange = !startDate.isSame(endDate);
  const status = getStatus(startDate, endDate);
  return (
    <div style={{ textAlign: 'left' }}>
      <Time value={startDate} format="M/D/YY" />
      {showDateRange && (
        <span>
          {' '}
          – <Time value={endDate} format="M/D/YY" />
        </span>
      )}
      <div className="flex flex-justify align-center m-b-4">
        <div className="report-date-column">
          <WidgetsStatusBadge sentiment={status} />
        </div>
      </div>
    </div>
  );
}

export default DateRange;
